import { config } from "../config";
import { callGateway, type CallerIdentity } from "./gateway";
import { shortName } from "../auth/scope";

/**
 * The operators beneath a namespace -- the console's "providers" -- from
 * radaccess GET /access/operator/{ns}/providers (v1.54, 2026-09-15). The
 * gateway answers only for the caller's own namespace or a descendant, on
 * the RBAC resource operatorproviders:read (superadmin, Operator, Reseller).
 */
export interface Provider {
  namespace: string;
  legalname: string;
  active: boolean;
  /** 1 = a direct child of the namespace asked about. */
  depth: number;
}

export interface ProvidersAnswer {
  parent: string;
  providers: Provider[];
}

export async function listProviders(identity: CallerIdentity, namespace: string, signal?: AbortSignal): Promise<ProvidersAnswer> {
  const r = await callGateway<ProvidersAnswer>(
    identity,
    config().gatewayBase,
    `/operator/${encodeURIComponent(namespace)}/providers`,
    signal ? { signal } : {},
  );
  return { parent: r.data?.parent ?? namespace, providers: r.data?.providers ?? [] };
}

/** The name a provider is shown by: its legal name, else its last segment. */
export function providerName(p: Pick<Provider, "namespace" | "legalname">): string {
  return p.legalname?.trim() || shortName(p.namespace);
}

/** Only the direct children, in namespace order. */
export function directProviders(all: Provider[]): Provider[] {
  return all.filter((p) => p.depth === 1);
}
